import React, { useState, useEffect, useRef } from "react";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "@vtaits/react-color-picker/dist/index.css";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import {
    Container,
    Button,
    Col,
    Row,
    Label,
    Card,
    CardBody,
    Input,
    InputGroup
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb3";
import {
    getCompanies as onGetCompanies,
    getListAccountNumber as onGetListAccountNumber,
    getListAccount as onGetListAccount,
    addAccountTransactionClient as onAddAccountTransactionClient
} from "../../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import CurrencyFormat from 'react-currency-format';
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { NotifHelper } from "../../../components/Common/NotifHelper"
import PulseLoader from "react-spinners/PulseLoader";

const ClientTransactionCreate = (props) => {
    //meta title
    document.title = "Add Transaction | Client Transaction | Des Counts";
    const dispatch = useDispatch();
    const [newTransaction, SetNewTransaction] = useState([])
    const [selectedCompany, setSelectedCompany] = useState(null)
    const [optionCompany, setOptionCompany] = useState(null)
    const [optionAccountNumber, setOptionAccountNumber] = useState(null)
    const [optionAccount, setOptionAccount] = useState(null)
    const optionType = [
        { label: "CREDIT", value: "credit" },
        { label: "DEBIT", value: "debit" },
    ]

    const {
        companies,
        loadingCompany,
        accountNumbers,
        loadingAccountNumber,
        accounts,
        loadingAccount,
        loading
    } = useSelector(state => ({
        companies: state.Company.companies,
        loadingCompany: state.Company.loading,
        accountNumbers: state.AccountNumber.listAccountNumber,
        loadingAccountNumber: state.AccountNumber.loading,
        accounts: state.Account.listAccount,
        loadingAccount: state.Account.loading,
        loading: state.AccountTransactionClient.loading,
    }));

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map(item => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [companies]);

    useEffect(() => {
        if (accountNumbers) {
            setOptionAccountNumber(accountNumbers.map(item => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [accountNumbers]);

    useEffect(() => {
        if (accounts) {
            setOptionAccount(accounts.map(item => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [accounts]);

    function handleSelectCompany(val) {
        setSelectedCompany(val)
    }

    const addTransaction = () => {
        const temp = {
            id: newTransaction.length > 0 ? newTransaction[newTransaction.length - 1].id + 1 : 1,
            date: null,
            accountNumberId: null,
            accountId: null,
            type: null,
            remarks: "",
            nominal: 0
        };
        const tempTransaction = [...newTransaction, temp]
        SetNewTransaction(tempTransaction)
    }

    function handleDeleteData(item) {
        const curData = newTransaction;
        var idx = curData.indexOf(item)
        if (idx > -1) {
            curData.splice(idx, 1)
            SetNewTransaction([...curData])
        }
    }

    function handleDateChange(e, id) {
        const dd = e[0].getDate().toString();
        const mm = e[0].getMonth() + 1;
        const yyyy = e[0].getFullYear();
        const curData = newTransaction;
        curData.map(m => {
            if (m.id == id) {
                m.date = String(yyyy).padStart(2, '0') + "-" + String(mm).padStart(2, '0') + "-" + String(dd).padStart(2, '0')
            }
        })
    }

    function handleNominalChange(val, id) {
        const curData = newTransaction;
        curData.map(m => {
            if (m.id == id) {
                m.nominal = isNaN(val.floatValue) ? 0 : val.floatValue
            }
        })
    }

    function handleRemarksChange(val, id) {
        const curData = newTransaction;
        curData.map(m => {
            if (m.id == id) {
                m.remarks = val
            }
        })
    }

    function handleSelectType(val, id) {
        const curData = newTransaction;
        curData.map(m => {
            if (m.id == id) {
                m.type = val ? val.value : null
            }
        })
    }

    function handleSelectAccount(val, id) {
        const curData = newTransaction;
        curData.map(m => {
            if (m.id == id) {
                m.accountId = val ? val.value : null
            }
        })
    }

    function handleSelectAccountNumber(val, id) {
        const curData = newTransaction;
        curData.map(m => {
            if (m.id == id) {
                m.accountNumberId = val ? val.value : null
            }
        })
    }

    function handleSubmit() {
        //check valid
        var validDetail = true
        newTransaction.map(item => {
            if (item.date == null || item.date.trim() == "") {
                validDetail = false
            }
            if (item.accountNumberId == null) {
                validDetail = false
            }
            if (item.remarks == null || item.remarks.trim() == "") {
                validDetail = false
            }
            if (item.nominal <= 0) {
                validDetail = false
            }
        })
        if (!validDetail || !selectedCompany || newTransaction.length == 0) {
            NotifHelper.error("Data not valid")
        }
        else {
            dispatch(onAddAccountTransactionClient({
                companyId: selectedCompany.value,
                detail: newTransaction.map(item => {
                    return {
                        date: item.date ?? null,
                        accountNumberId: item.accountNumberId ?? null,
                        accountId: item.accountId ?? null,
                        type: item.type ?? null,
                        remarks: item.remarks ?? null,
                        nominal: item.nominal ?? null,
                    }
                })
            }, props.history))
        }
    }

    useEffect(() => {
        dispatch(onGetCompanies({}))
    }, [dispatch])

    useEffect(() => {
        if (selectedCompany) {
            dispatch(onGetListAccountNumber({ companyId: selectedCompany.value }))
            dispatch(onGetListAccount({ companyId: selectedCompany.value }))
            SetNewTransaction([])
        }
    }, [selectedCompany])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Client Transaction" breadcrumbItem1="Transaction" breadcrumbItem2="Add Transaction" />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <Row className="mb-3">
                                        <Col>
                                            <div>
                                                <Label>Company</Label><Label className="text-danger">*</Label>
                                                <Select
                                                    value={selectedCompany}
                                                    onChange={(val) => {
                                                        handleSelectCompany(val)
                                                    }}
                                                    options={optionCompany}
                                                    isLoading={loadingCompany}
                                                    isClearable={false}
                                                    className="select2-selection"
                                                    menuPosition="fixed"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <h5 className="mt-4 text-center">Transaction Data</h5>
                                    <hr className="mb-2" />
                                    {
                                        newTransaction && newTransaction.map((item, i) => {
                                            return <Row className="mt-3" key={'row' + i}>
                                                <Col>
                                                    <Label>Date</Label><Label className="text-danger">*</Label>
                                                    <InputGroup>
                                                        <Flatpickr
                                                            className={"form-control d-block"}
                                                            placeholder="Select Date"
                                                            options={{
                                                                dateFormat: "Y-m-d"
                                                            }}
                                                            onChange={e => handleDateChange(e, item.id)}
                                                            value={item.date}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                                <Col>
                                                    <div>
                                                        <Label>Account Number</Label><Label className="text-danger">*</Label>
                                                        <Select
                                                            onChange={(val) => {
                                                                handleSelectAccountNumber(val, item.id)
                                                            }}
                                                            options={optionAccountNumber}
                                                            isLoading={loadingAccountNumber}
                                                            isClearable={false}
                                                            className="select2-selection"
                                                            menuPosition="fixed"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div>
                                                        <Label>Account</Label>
                                                        <Select
                                                            onChange={(val) => {
                                                                handleSelectAccount(val, item.id)
                                                            }}
                                                            options={optionAccount}
                                                            isLoading={loadingAccount}
                                                            isClearable={false}
                                                            className="select2-selection"
                                                            menuPosition="fixed"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div>
                                                        <Label>Type</Label>
                                                        <Select
                                                            onChange={(val) => {
                                                                handleSelectType(val, item.id)
                                                            }}
                                                            options={optionType}
                                                            isClearable={true}
                                                            className="select2-selection"
                                                            menuPosition="fixed"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div>
                                                        <Label>Remarks</Label><Label className="text-danger">*</Label>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            onChange={e => {
                                                                handleRemarksChange(e.target.value, item.id)
                                                            }}
                                                            placeholder={'Enter ...'}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div>
                                                        <Label>Nominal</Label><Label className="text-danger">*</Label>
                                                        <CurrencyFormat value={item.nominal} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                                                            onValueChange={(values) => {
                                                                handleNominalChange(values, item.id)
                                                            }}
                                                            customInput={Input} className="text-end" />
                                                    </div>
                                                </Col>
                                                <Col sm={1} className="text-center align-self-end">
                                                    <Button color="danger" onClick={() => {
                                                        handleDeleteData(item)
                                                    }}>
                                                        <i className="fa fa-trash"></i>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        })
                                    }
                                    {
                                        !loading &&
                                        <>
                                            <Row className="mb-3 mt-3">
                                                <Col className="text-center">
                                                    <Button color="secondary" onClick={addTransaction}>
                                                        <span><i className="fa fa-plus"></i> Add</span>
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Link to="/client-transaction/transaction">
                                                        <Button color="primary" className="float-end">
                                                            Cancel
                                                        </Button>
                                                    </Link>
                                                    <Button color="success" className="float-end me-2" onClick={() => {
                                                        handleSubmit()
                                                    }}>
                                                        Submit
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                    {
                                        loading &&
                                        <Row className="mt-3">
                                            <Col className="text-center">
                                                <PulseLoader size={10} color={'#fff'} className="text-white" />
                                            </Col>
                                        </Row>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

ClientTransactionCreate.propTypes = {
    className: PropTypes.string,
    preGlobalFilteredRows: PropTypes.any,
};

export default ClientTransactionCreate
